import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {RecoverPasswordForm} from '../recover-password-form';
import {Alert} from '../../../utils/alert';
import {ValidatorUtils} from '../../../utils/validator-utils';
import {UserService} from '../../../services/security/user.service';
import {PasswordService} from '../../../services/security/password.service';
import {TranslateService} from '@ngx-translate/core';
import {PasswordSecurity} from '../../../model/security/password-security';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  private static readonly INVALID_RESET_TOKEN_KEY = 'error.message.invalid_reset_token';

  @Input() token!: string;
  @Input() mode: 'reset' | 'init' = 'reset';
  @Output() cancel = new EventEmitter<void>();
  @Output() done = new EventEmitter<void>();
  @Output() expired = new EventEmitter<void>();

  get titleKey(): string {
    return this.mode === 'init' ? 'login.init_password_title' : 'login.reset_password_title';
  }

  recoverPasswordForm = RecoverPasswordForm.getForm();
  readonly RecoverPasswordForm = RecoverPasswordForm;

  displayErrorDynamic = false;
  loading = false;
  passwordSecurity: PasswordSecurity | undefined;
  alert: Alert | undefined;

  constructor(
    private userService: UserService,
    public passwordService: PasswordService,
    public translateService: TranslateService
  ) {}

  ngOnInit(): void {
    this.userService.getPasswordSecurity().subscribe(
      passwordSecurity => {
        this.passwordSecurity = passwordSecurity;
        this.recoverPasswordForm = RecoverPasswordForm.getForm(this.passwordSecurity);
      }
    );
  }

  resetPassword() {
    if (this.loading) {
      return;
    }
    this.displayErrorDynamic = true;
    const password = RecoverPasswordForm.getValue(this.recoverPasswordForm);

    // @ts-ignore
    if (this.passwordService.checkPasswords(this.passwordSecurity, password.newPassword, password.confirmPassword)) {
      if (this.recoverPasswordForm.valid) {
        this.loading = true;
        // @ts-ignore
        this.userService.resetPassword(this.token, password.newPassword).subscribe(
          apiValidation => {
            if (apiValidation.success) {
              this.done.emit();
            } else if (apiValidation.message === ResetPasswordComponent.INVALID_RESET_TOKEN_KEY) {
              this.expired.emit();
            } else {
              this.alert = new Alert(Alert.Status.ERROR, '', {key: apiValidation.message, params: {}});
            }
            this.loading = false;
          },
          err => {
            console.error('Can\'t reset password', err);
            this.loading = false;
          }
        );
      } else {
        this.alert = ValidatorUtils.getFormError(this.recoverPasswordForm, RecoverPasswordForm.FIELDS.NEW_PASSWORD)
          .getAlert(Alert.Status.ERROR, this.translateService);
      }
    } else {
      // @ts-ignore
      const reason = this.passwordService.getFailureReason(this.passwordSecurity, password.newPassword, password.confirmPassword);
      this.alert = new Alert(Alert.Status.ERROR, '', reason || {key: 'error.message.not_valid_data', params: {}});
    }
  }

  getError(): string | undefined {
    let error: string | undefined;

    if (this.displayErrorDynamic && this.recoverPasswordForm.invalid && (this.recoverPasswordForm.dirty || this.recoverPasswordForm.touched)) {
      error = ValidatorUtils.getFormError(this.recoverPasswordForm, RecoverPasswordForm.FIELDS.NEW_PASSWORD).getI18n(this.translateService);
    }
    if (error) {
      this.alert = undefined;
    }
    if (!error && this.alert) {
      error = this.translateService.instant(this.alert.detail.key, this.alert.detail.params);
    }
    return error;
  }
}
